var _style, _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#555555;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,1C3.7,1,1,3.7,1,7s2.7,6,6,6s6-2.7,6-6C13,3.7,10.3,1,7,1 M7,0c3.9,0,7,3.1,7,7s-3.1,7-7,7s-7-3.1-7-7 S3.1,0,7,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,8.6C6.6,8.5,6.5,8.4,6.5,8.3V3.4c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5l0,4.9 c0,0.3-0.2,0.5-0.5,0.5C6.9,8.8,6.7,8.7,6.6,8.6L6.6,8.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7,
    cy: 10.7,
    r: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.b517515be3d5d56dce0f503847950b23.svg";
export { ForwardRef as ReactComponent };